import { SxProps, Theme } from '@mui/material';

const button: SxProps<Theme> = {
  p: 0
};

export const sourceExternallyButtonSx = {
  button
};
